var exports = {
  "O": "LanguageCircleIndicator__fP19fC",
};

module.exports = exports;
